import React, { useEffect, useState } from 'react';
import { Phone, Mail, MapPin, Send } from 'lucide-react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function Footer() {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    axios.get(`${API}/api/public/settings`).then(res => setSettings(res.data));
  }, []);

  return (
    <footer className="bg-slate-900 text-slate-300 py-16 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid md:grid-cols-3 gap-12">
        <div className="space-y-6">
          <img src="https://customer-assets.emergentagent.com/job_dentakron-dental/artifacts/k9vx59de_123.png" alt="Dentakron Logo" className="h-16 w-auto bg-white p-2 rounded-xl" />
          <p className="text-slate-400 max-w-sm">
            Dinamik, güler yüzlü ve deneyimli ekibimizle sizlere "Mis gibi bir gülüş" kazandırıyoruz. Modern diş hekimliğinin tüm olanaklarıyla yanınızdayız.
          </p>
          
          {/* Social Media Icons */}
          <div className="flex space-x-4">
            {/* Instagram */}
            {settings.instagram_active && settings.instagram && (
              <a href={settings.instagram} target="_blank" rel="noreferrer" className="hover:scale-110 transition-transform">
                <img src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png" alt="Instagram" className="w-10 h-10 rounded-full object-cover" />
              </a>
            )}

            {/* Facebook */}
            {settings.facebook_active && settings.facebook && (
              <a href={settings.facebook} target="_blank" rel="noreferrer" className="hover:scale-110 transition-transform">
                <img src="https://www.deskera.com/blog/content/images/2021/11/alexander-shatov-CTZhGbSxWLI-unsplash.jpg" alt="Facebook" className="w-10 h-10 rounded-full object-cover" />
              </a>
            )}

            {/* Telegram */}
            {settings.telegram_active && settings.telegram && (
              <a href={settings.telegram} target="_blank" rel="noreferrer" className="hover:scale-110 transition-transform">
                <img src="https://www.ipvanish.com/wp-content/uploads/2023/01/istelegramsafe_IPV-blog.png" alt="Telegram" className="w-10 h-10 rounded-full object-cover" />
              </a>
            )}
          </div>
        </div>

        <div>
          <h4 className="text-white text-lg font-bold mb-6 font-heading">Hızlı Bağlantılar</h4>
          <ul className="space-y-3">
            <li><a href="#tedaviler" className="hover:text-primary transition-colors">Tedavilerimiz</a></li>
            <li><a href="#hekimlerimiz" className="hover:text-primary transition-colors">Uzman Kadromuz</a></li>
            <li><a href="#oncesi-sonrasi" className="hover:text-primary transition-colors">Öncesi & Sonrası</a></li>
            <li><a href="#iletisim" className="hover:text-primary transition-colors">İletişim</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white text-lg font-bold mb-6 font-heading">İletişim Bilgileri</h4>
          <ul className="space-y-4">
            <li className="flex items-start gap-4">
              <MapPin className="w-6 h-6 text-primary flex-shrink-0" />
              <span>{settings.address || 'Aşağı Öveçler Mahallesi Kabil Caddesi 68/A Çankaya'}</span>
            </li>
            <li className="flex items-center gap-4">
              <Phone className="w-6 h-6 text-primary flex-shrink-0" />
              <a href={`tel:${settings.phone}`} className="hover:text-white transition-colors">{settings.phone || '+90 555 555 5555'}</a>
            </li>
            <li className="flex items-center gap-4">
              <Mail className="w-6 h-6 text-primary flex-shrink-0" />
              <a href={`mailto:${settings.email}`} className="hover:text-white transition-colors">{settings.email || 'info@dentakron.com'}</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 mt-12 pt-8 border-t border-slate-800 text-center text-sm text-slate-500">
        <p>© {new Date().getFullYear()} Dentakron Diş Kliniği. Tüm Hakları Saklıdır.</p>
      </div>
    </footer>
  );
}
